export default "__VITE_PUBLIC_ASSET__b749f4a4__"